import dates from '@/assets/js/dates'

export const connection = {
  label: 'Connection',
  key: 'connection_id',
  icon: 'pulse',
  tooltip: 'Limit results to a set of selected partners.'
}

export const invoicedAt = {
  label: 'Invoice Submitted',
  key: 'invoiced_at',
  icon: 'calendar',
  tooltip: 'This is a tooltip',
  options: dates
}
